// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AR9x","image":"Header_image__1J6-e","name":"Header_name__givfg","info":"Header_info__3qK3o","infoRow":"Header_infoRow__GumCn"};